import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { PagedMenuResponse } from '../../models/menu/api-menu-item';

@Injectable({ providedIn: 'root' })
export class MenuApiService {
  constructor(private readonly generic: GenericService) {}

  getMyMenus(): Observable<PagedMenuResponse> {
    return this.generic.get<PagedMenuResponse>('menu/my-menus');
  }
}
